var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForest = function SvgForest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1164 7.269C11.6674 7.174 12.2849 7.098 12.9784 7.041C16.6834 6.756 18.9254 4.932 19.6189 2.5C14.7264 4.8275 8.62736 1.9775 7.47786 7.1265L6.88886 9.8625C6.88886 9.8625 6.88886 9.8625 6.88886 9.853C6.88886 9.872 6.88886 9.8815 6.87936 9.8815L5.78686 14.9165L5.15036 17.8805L4.38086 21.5C8.13336 21.2815 8.65586 17.2725 9.25436 14.299C10.0999 13.9665 10.7744 13.8335 10.9549 13.7955C14.1374 13.102 15.6669 11.4775 16.2749 9.359C14.7739 10.2425 12.1804 10.0525 9.92886 10.6415C9.95736 10.6415 9.97636 10.6225 9.99536 10.613C10.0429 10.2995 10.5559 8.048 11.1164 7.269Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "forest.b79ef680810c355740808e3771d365ca.svg";